import request from '@/util/request';
import qs from 'qs';
// 群众诉求管理
export const getList = (params, options) =>
request.get('/api/v4ward/community/mass/demands/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/community/mass/demands/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/community/mass/demands/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/community/mass/demands/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/community/mass/demands/update', params,options)
